
import { useEffect, useState } from 'react';
import styles from './styles.module.css';
import Image from "@/shared/components/Image/new";

const AccesosDirectos = (props) => {
    const {
        title,
        link,
        title1,
        link1,
        title2,
        link2,
        title3,
        link3,
        linkImage,
        limit
    } = props;

    const [rio, setRio] = useState({
        valor: title3 || 'VER ALTURA',
        texto: 'altura en el Puerto',
        color: 'azul'
    });

    // =====================================
    // DATOS DINÁMICOS DEL RÍO PARANÁ
    // =====================================

    useEffect(() => {
        const DATOS = 'https://widget-rios.ellitoral.com/datos.json';
        const controller = new AbortController();

        const formato = (valor) => {
            return valor.toLocaleString('es-AR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        };

        fetch(DATOS, { signal: controller.signal })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Error al consultar los datos del río');
                }
                return response.json();
            })
            .then((data) => {

                const observaciones = data.observaciones;
                const niveles = data.niveles;

                if (!observaciones || observaciones.length === 0 || !niveles) {
                    return;
                }

                const ultima = observaciones[observaciones.length - 1];
                const anterior = observaciones[observaciones.length - 2];

                // Evitar mostrar datos con más de 48 horas
                const fecha = new Date(ultima.t);

                if (
                    isNaN(fecha.getTime()) ||
                    (Date.now() - fecha.getTime()) / 864e5 >= 2
                ) {
                    return;
                }

                // Variación respecto de la medición anterior
                const centimetros = anterior
                    ? Math.round((ultima.v - anterior.v) * 100)
                    : 0;

                let color = 'azul';
                let texto = 'faltan ' + formato(niveles.alerta - ultima.v) + ' m para la alerta';

                // Nivel de evacuación
                if (ultima.v >= niveles.evac) {
                    color = 'rojo';
                    texto = 'superó la evacuación (' + formato(niveles.evac) + ' m)';
                }

                // Nivel de alerta
                else if (ultima.v >= niveles.alerta) {
                    color = 'naranja';
                    texto = 'superó la alerta (' + formato(niveles.alerta) + ' m)';
                }

                const flecha =
                    centimetros > 0 ? ' ▲' :
                    centimetros < 0 ? ' ▼' : '';

                setRio({
                    valor: formato(ultima.v) + ' m' + flecha,
                    texto,
                    color
                });

            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    console.error('Error al obtener altura de ríos:', error);
                }
            });

        return () => controller.abort();

    }, [title3]);


    // =====================================
    // CABEZAL
    // =====================================

    let cabezal = "";

    if (linkImage) {
        cabezal = <Image src={linkImage} />;
    }

    if (title && link) {
        cabezal = <h2><a href={link}>{title}</a></h2>;
    }

    if (title && !link) {
        cabezal = <h2>{title}</h2>;
    }


    // =====================================
    // RENDER
    // =====================================

    return (
        <div>
            <div className={styles['title-content']}>

                {(title || linkImage) && (
                    <div className={styles["contenedor-gral-tittulo-container"]}>

                        <div className={styles["contenedor-left-titulo"]}>
                            {cabezal}
                        </div>

                        <div className={styles["scroll-margin"]}>

                            <nav
                                className={styles["menu-el-scroll"]}
                                aria-label="Accesos directos"
                            >

                                <ul className={styles["accesos-lista"]}>

                                    {/* SANTA FE 24/7 */}
{link1 && title1 && (
    <li className={`${styles["acceso-item"]} ${styles["accesos-d1"]}`}>
        <div className={styles["acceso-info"]}>
            <b>SANTA FE 24/7</b>
            <span className={styles["acceso-descripcion"]}>
                Cámaras, clima y actualidad
            </span>
        </div>

        <a className={styles["acceso-boton"]} href={link1}>
            {title1}
        </a>
    </li>
)}

{/* ESTADO DEL TRÁNSITO */}
{link2 && title2 && (
    <li className={`${styles["acceso-item"]} ${styles["accesos-d2"]}`}>
        <div className={styles["acceso-info"]}>
            <b>ESTADO DEL TRÁNSITO</b>
            <span className={styles["acceso-descripcion"]}>
                minuto a minuto
            </span>
        </div>

        <a className={styles["acceso-boton"]} href={link2}>
            {title2}
        </a>
    </li>
)}

                                    {link3 && title3 && (
                                        <li className={`${styles["acceso-item"]} ${styles["accesos-d3"]}`}>

                                            <div className={styles["acceso-info"]}>

                                                <b>RÍO PARANÁ</b>

                                                <span className={styles["acceso-descripcion"]}>
                                                    {rio.texto}
                                                </span>

                                            </div>

                                            <a
                                                className={`${styles["acceso-boton"]} ${styles["rio-boton"]} ${styles["rio-boton-" + rio.color]}`}
                                                href={link3}
                                            >
                                                {rio.valor}
                                            </a>

                                        </li>
                                    )}

                                </ul>

                            </nav>

                        </div>

                    </div>
                )}

            </div>
        </div>
    );
};

export default AccesosDirectos;
